import { Flex, HelpTip, Link } from "@amzn/storm-ui";

import { TROUBLESHOOTING_WIKI } from "../../../../constants/links";
import { StyledFailedText } from "../../../common/styled.components";

export const ArtifactGenerationFailedAction: React.FunctionComponent<{
    executionId: string;
}> = ({ executionId }) => {
    return (
        <Flex alignItems="center">
            <StyledFailedText>Failed to create</StyledFailedText>
            <HelpTip id={`${executionId}-artifacts-generation-fail`}>
                Insight deck failed to create during data retrieval. Please
                visit the{" "}
                <Link target="_blank" href={TROUBLESHOOTING_WIKI}>
                    template wiki page
                </Link>{" "}
                to learn more.
            </HelpTip>
        </Flex>
    );
};
